import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

export default class extends Controller {
  static targets = ['picker', 'start', 'end', 'form', 'menu', 'timezone', 'button']

  connect () {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
  }

  disconnect () {
    document.removeEventListener('click', this.boundHandleClickOutside)
    if (this.fp) {
      this.fp.destroy()
      this.fp = null
    }
  }

  toggleDropdown (event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains('hidden')) {
      this.menuTarget.classList.remove('hidden')
      setTimeout(() => {
        document.addEventListener('click', this.boundHandleClickOutside)
      }, 0)
    } else {
      this.closeDropdown()
    }
  }

  closeDropdown () {
    this.menuTarget.classList.add('hidden')
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  handleClickOutside (event) {
    if (
      !this.element.contains(event.target) &&
      (!this.fp || !this.fp.calendarContainer.contains(event.target))
    ) {
      this.closeDropdown()
      this.closeDatepicker()
    }
  }

  openDatepicker (event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.fp) {
      this.fp.open()
      return
    }

    this.fp = flatpickr(this.pickerTarget, {
      mode: 'range',
      dateFormat: 'Y-m-d',
      disable: [(date) => date > new Date()],
      defaultDate: [this.startTarget.value, this.endTarget.value],
      monthSelectorType: 'static',
      appendTo: this.element,
      onReady: (selectedDates, dateStr, instance) => {
        this.fp = instance
        this.positionCalendar(instance)
      },
      onClose: (selectedDates) => {
        this.handleClose(selectedDates)
      }
    })

    this.fp.open()
  }

  positionCalendar (instance) {
    window.requestAnimationFrame(() => {
      instance.calendarContainer.classList.add('!opacity-0')
      instance.calendarContainer.classList.remove('translate-x-[-125px]')

      const menuRect = this.menuTarget.getBoundingClientRect()
      const calendarRect = instance.calendarContainer.getBoundingClientRect()
      const viewportWidth = window.innerWidth
      const calendarWidth = calendarRect.width
      const spacing = 10

      let horizontalOffset = menuRect.right + spacing - calendarRect.left
      let verticalOffset = menuRect.top - calendarRect.top

      const rightEdge = menuRect.right + spacing + calendarWidth
      if (rightEdge > viewportWidth) {
        horizontalOffset = menuRect.left - spacing - calendarWidth - calendarRect.left
      }

      const leftEdge = menuRect.left - spacing - calendarWidth
      if (leftEdge < 0) {
        horizontalOffset = spacing - calendarRect.left
      }

      const bottomEdge = menuRect.bottom + calendarRect.height
      if (bottomEdge > window.innerHeight) {
        verticalOffset = window.innerHeight - calendarRect.height - spacing - calendarRect.top
      }

      instance.calendarContainer.style.transform = `translate(${horizontalOffset}px, ${verticalOffset}px)`
      instance.calendarContainer.style.transformOrigin = 'top left'

      setTimeout(() => {
        instance.calendarContainer.classList.remove('!opacity-0')
      }, 300)
    })
  }

  closeDatepicker () {
    if (this.fp && this.fp.isOpen) {
      this.fp.close()
    }
  }

  handleClose (selectedDates) {
    if (selectedDates.length >= 1) {
      const startDate = selectedDates[0].toISOString().split('T')[0]
      const endDate = selectedDates.length === 2
        ? selectedDates[1].toISOString().split('T')[0]
        : startDate

      this.startTarget.value = startDate
      this.endTarget.value = endDate
      this.timezoneTarget.value = window.localTimezone

      this.closeDropdown()
      this.formTarget.requestSubmit()
    }
  }
}
